export type GridEditMode = "move" | "start" | "end";

/** Local calendar dates preserve the selected day across daylight-saving changes. */
export function editGridTime(
  start: Date,
  end: Date,
  day: Date,
  deltaMinutes: number,
  mode: GridEditMode,
): { start: Date; end: Date } {
  const delta = Math.round(deltaMinutes / 15) * 15;
  const nextStart = new Date(start);
  const nextEnd = new Date(end);
  const min = new Date(start);
  min.setHours(0, 0, 0, 0);
  const max = new Date(start);
  max.setHours(24, 0, 0, 0);
  if (mode === "move") {
    const minute = Math.max(0, Math.min(1425, start.getHours() * 60 + start.getMinutes() + delta));
    nextStart.setFullYear(day.getFullYear(), day.getMonth(), day.getDate());
    nextStart.setHours(0, minute, start.getSeconds(), start.getMilliseconds());
    nextEnd.setTime(nextStart.getTime() + end.getTime() - start.getTime());
  } else if (mode === "start") {
    nextStart.setTime(
      Math.max(
        min.getTime(),
        Math.min(end.getTime() - 15 * 60_000, start.getTime() + delta * 60_000),
      ),
    );
  } else {
    nextEnd.setTime(
      Math.max(
        start.getTime() + 15 * 60_000,
        Math.min(Math.max(max.getTime(), end.getTime()), end.getTime() + delta * 60_000),
      ),
    );
  }
  return { start: nextStart, end: nextEnd };
}
